import React from 'react';
import { Question, Answer } from '../types';
import { Textarea } from './ui/Textarea';

interface QuestionnaireSectionProps {
  category: string;
  questions: Question[];
  answers: Answer[];
  onAnswerChange: (questionId: string, response: string) => void;
}

export const QuestionnaireSection: React.FC<QuestionnaireSectionProps> = ({
  category,
  questions,
  answers,
  onAnswerChange,
}) => {
  return (
    <div className="space-y-6">
      {questions.map((question) => (
        <div key={question.id} className="space-y-2">
          <label 
            htmlFor={question.id}
            className="block text-lg font-medium text-gray-700"
          >
            {question.text}
          </label>
          <Textarea
            id={question.id}
            value={answers.find(a => a.questionId === question.id)?.response || ''}
            onChange={(e) => onAnswerChange(question.id, e.target.value)}
            className="w-full min-h-[100px]"
            placeholder="Type your answer here..."
          />
        </div>
      ))}
    </div>
  );
}